import React, { useState } from 'react';
import { FaCaretDown, FaCaretUp, FaCircle } from 'react-icons/fa';
import styles from '../../css/CourseInfo.module.css';

function CourseInfo({ coursedata }) {
	const [activeContent, setActiveContent] = useState({});

	const handleToggleContent = (itemId) => {
		setActiveContent((prevState) => ({
			...prevState,
			[itemId]: !prevState[itemId],
		}));
	};

	return (
		<div className={styles.main}>
			{coursedata.map((item) => {
				const isContentActive = activeContent[item.id];
				return (
					<div key={item.id} className={styles.main1}>
						<p className={styles.title}>{item.title}</p>
						<p className={styles.sub_title}>{item.sub_title}</p>
						<div className={styles.row}>
							<p className={styles.head}>Eligibility :</p>
							<p className={styles.txt}>{item.eligibility}</p>
						</div>
						<div className={styles.row}>
							<p className={styles.head}>Duration :</p>
							<p className={styles.txt}>{item.duration}</p>
						</div>
						<div>
							<div className={styles.row1}>
								<p className={styles.head}>Content</p>
								<div className={styles.row}>
									{isContentActive ? (
										<FaCaretUp
											className={styles.icon}
											color="red"
											onClick={() => {
												handleToggleContent(item.id);
											}}
										/>
									) : (
										<FaCaretDown
											className={styles.icon}
											onClick={() => {
												handleToggleContent(item.id);
											}}
										/>
									)}
								</div>
							</div>
							<div className={isContentActive ? styles.colum : styles.none}>
								{item.content.map((contentItem, index) => {
									return (
										<div key={index} className={styles.row2}>
											<div>
												<FaCircle size={6} />
											</div>
											<p className={styles.cont}>{contentItem}</p>
										</div>
									);
								})}
							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
}

export default CourseInfo;


 
